const MACRO_REGEX = /\{\{\s*([A-Za-z0-9_]+)\s*\}\}/g;

export function renderEmailTemplate(template: string, context: Record<string, string>): string {
  if (!template) {
    return '';
  }

  const lookup = new Map(
    Object.entries(context).map(([key, value]) => [key.toLowerCase(), value ?? ''])
  );

  return template.replace(MACRO_REGEX, (_, macroName: string) => {
    return lookup.get(macroName.toLowerCase()) ?? '';
  });
}

export function hasFilledMacroValues(
  macros: Array<{ name: string }>,
  values: Record<string, string>
): boolean {
  return macros.some((macro) => Boolean(values[macro.name]?.trim()));
}
